<template>
	<div class="radio-contain" :class="{disabled}">
		<p class="label">{{ label }}<span class="required" v-if="required"> *</span></p>
		<div class="radio-row">
			<label>
				<input 
					type="radio" 
					:name="name" 
					class="radio-input" 
					value="yes" 
					@input="$emit('update:value', 'yes')"
					:checked="value === 'yes'"
					:disabled="sameAsActive">
				<span>Yes</span>
			</label>
			<label>
				<input 
					type="radio" 
					:name="name" 
					class="radio-input" 
					value="no" 
					@input="$emit('update:value', 'no')"
					:checked="value === 'no'"
					:disabled="sameAsActive">
				<span>No</span>
			</label>
		</div>
	</div>
</template>

<script>
export default {
	name: 'YesNo',
	props:{
		required:{
			type: Boolean,
			default: false,
		},
		name: {
			type: String,
			default: ''
		},
		value: {
			type: String,
			required: false
		},
		label: {
			type: String,
			default: ''
		},
		sameValue:{
			type: String,
			required: false
		},
		sameAsActiveExternal: {
			type: Boolean,
			default: false
		},
	},
	data() {
		return {
			sameAsActive: false
		}
	},
}
</script>

<style lang="scss" scoped>

	.radio-contain{
		margin: 2rem 0;

		&.less-margin{
			margin: 1rem 0;
		}

		&.disabled{
			opacity: .7;
		}
	}

	label{
		display: inline-block;
		cursor: pointer;
		margin-top: .5rem;
		
		span{
			padding: 10px 35px;
			display: inline-block;
			position: relative;

			&:after{
				content:'';
				border: solid 2px #fff;
				height: 16px;
				width: 16px;
				position: absolute;
				top: 10px;
				left: 10px;
				border-radius: 100px;
			}
		}

		input:checked + span:after{
			background: var(--yellow);
			border-color: var(--yellow);
		}
	}

	.radio-input{
		display: none;
	}
	
	.required{
		color: var(--red);
	}
</style>